import { render, staticRenderFns } from "./AppStatus.vue?vue&type=template&id=165afe45&scoped=true"
import script from "./AppStatus.vue?vue&type=script&lang=js"
export * from "./AppStatus.vue?vue&type=script&lang=js"
import style0 from "./AppStatus.vue?vue&type=style&index=0&id=165afe45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165afe45",
  null
  
)

export default component.exports